import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { useLegalAgreements } from "../../hooks/useLegalAgreements"; // Updated import

const LegalAgreementsModal: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<"preliminary" | "sales">(
    "preliminary"
  );

  // Use the renamed hook
  const { generateHtml, isLoading, isReady, templates } = useLegalAgreements();

  if (isLoading || !isReady) {
    return (
      <div style={{ padding: "1rem" }}>
        <Skeleton count={5} />
      </div>
    );
  }

  if (!templates) {
    return <p>{t("feedback.default.error", "Error loading agreements.")}</p>;
  }

  const preliminaryHtml = generateHtml(templates.preliminaryInfo);
  const salesAgreementHtml = generateHtml(templates.distanceSalesAgreement);

  return (
    <div className="legal-agreements-modal">
      <div className="legal-agreements-modal__tabs">
        <button
          className={`legal-agreements-modal__tab ${
            activeTab === "preliminary" ? "is-active" : ""
          }`}
          onClick={() => setActiveTab("preliminary")}
        >
          {t("legalAgreements.preliminaryForm", "Preliminary Information Form")}
        </button>
        <button
          className={`legal-agreements-modal__tab ${
            activeTab === "sales" ? "is-active" : ""
          }`}
          onClick={() => setActiveTab("sales")}
        >
          {t("legalAgreements.salesAgreement", "Distance Sales Agreement")}
        </button>
      </div>

      <div className="legal-agreements-modal__content">
        <div
          className="wysiwyg-content"
          dangerouslySetInnerHTML={{
            __html:
              activeTab === "preliminary"
                ? preliminaryHtml
                : salesAgreementHtml,
          }}
        />
      </div>
    </div>
  );
};

export default LegalAgreementsModal;
